import { render, staticRenderFns } from "./RegiaoImportarForm.vue?vue&type=template&id=7bd9465a"
import script from "./RegiaoImportarForm.vue?vue&type=script&lang=js"
export * from "./RegiaoImportarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports